import theme from '@ifca-root/react-component/src/assets/theme';
import CardContents from '@ifca-root/react-component/src/components/CardList/CardContents';
import EmptyList from '@ifca-root/react-component/src/components/CardList/EmptyList';
import { DynamicFooter } from 'components/Footer/DynamicFooter';
import DynamicSubHeader from '@ifca-root/react-component/src/components/Header/DynamicSubHeader';
import { MainHeader } from '@ifca-root/react-component/src/components/Header/MainHeader';
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper';
import {
	StyledMenu,
	StyledMenuItem,
} from '@ifca-root/react-component/src/components/others/Menu';
import { ListItemText, useMediaQuery } from '@material-ui/core';
import ShareIcon from '@material-ui/icons/Share';
import AppContext from 'containers/App/Store/AppContext';
import {
	useCreateReceiptAttachmentMutation,
	useEmailSendMutation,
	useGetAverageMealTimeAnalysisLazyQuery,
	useGetBizInsightOutletQuery,
	useGetShareAttachmentMutation,
} from 'generated/graphql';
import { useMenuOption } from 'helpers/hooks/useMenuOption';
import * as htmlToImage from 'html-to-image';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
	Bar,
	BarChart,
	CartesianGrid,
	Cell,
	LabelList,
	ResponsiveContainer,
	Tooltip,
	XAxis,
	YAxis,
} from 'recharts';
import ShareDialog, { EmailDialog, PhoneNumDialog } from '../../../../../components/Dialog/ShareDialog';
import '../bi.scss';
import ReactDOMServer from 'react-dom/server';
import SnackBarMsg from '@ifca-root/react-component/src/components/SnackBar/SnackBarMsg';
import { useSnackBar } from 'helpers/hooks/useSnackBar';


const COLORS = ['#25D0CF', '#FFB10A', '#446FF7', '#ffc853', '#f8f0d7'];
export const AverageMealTimeAnalysis = () => {
	const history = useHistory();
	const { anchorEl, menu, handleClick, handleClose } = useMenuOption();
	const loggedInUser = JSON.parse(localStorage.getItem('loggedInUser'));
	const latestOutlet = localStorage.getItem('latestOutlet');
	const dateFormat = require('dateformat');

	const { globalState } = useContext(AppContext as any);
	const isDesktop = useMediaQuery(theme.breakpoints.up('sm'), {
		defaultMatches: true,
	});

	const {
		data: { getOutlet } = { getOutlet: [] },
		called: getOutletCalled,
		loading: getOutletLoading,
	} = useGetBizInsightOutletQuery({
		fetchPolicy: 'network-only',
	});

	const [selectedOutlet, setSelectedOutlet] = useState(null);
	useEffect(() => {
		setSelectedOutlet(
			getOutlet?.filter(outlet => outlet?.ID === latestOutlet)[0],
		);
	}, [getOutlet]);

	const [
		loadAverageMealTimeAnalysis,
		{
			data: { averageMealTimeAnalysis } = { averageMealTimeAnalysis: [] },
			called: averageMealTimeAnalysisCalled,
			loading: averageMealTimeAnalysisLoading,
		},
	] = useGetAverageMealTimeAnalysisLazyQuery({
		fetchPolicy: 'network-only',
	});

	const [openShareDialog, setOpenShareDialog] = useState(false);
	const [openSendEmail, setOpenSendEmail] = useState(false);
	const [openPhoneNum, setOpenPhoneNum] = useState(false);
	const [email, setEmail] = useState('');
	const [openEmail, setOpenEmail] = useState(false);
	const [phoneNumber, setPhoneNumber] = useState('');
	const { snackFunc, snackBarMessage, openSnackBar } = useSnackBar();
	const [
		getShareAttachment,
		{
			data: { shareAttachment } = { shareAttachment: {} as any },
			called: shareAttachmentCalled,
			loading: shareAttachmentLoading,
		},
	] = useGetShareAttachmentMutation({
		onCompleted: () => {
			setOpenShareDialog(true);
		},
	});

			const [ 
				createAttachment,
				{
					data: {  } = {
						createReceiptAttachment: {} as any,
					},
					called: createReceiptAttachmentCalled,
					loading: createReceiptAttachmentLoading,
				},
			] = useCreateReceiptAttachmentMutation({});

		const [
					EmailSend,
					{
						data: { emailSend } = { emailSend: {} as any },
						loading: loadingEmailSend,
					},
				] = useEmailSendMutation({});

	  				const ContentShare = () => (
				<div
					className="content-container"
					style={{
						position: 'fixed',
						top: '50%',
						left: '50%',
						transform: 'translate(-50%, -50%)',
					}}
				>
					<a target="_blank" rel="noopener noreferrer">
						<img
							src={shareAttachment?.fileURL}
							alt="Displayed Image"
							width="500px"
							height="500px"
						/>
					</a>
				</div>
			);
		
			const body = `Dear Customer,
		
		
		Please find the attached Average Meal Time Analysis. The details as follows:
		
		Outlet Name: ${selectedOutlet?.name}
		`;
		
			useEffect(() => {
				const QRContentString = ReactDOMServer.renderToStaticMarkup(ContentShare());
		
				openSendEmail &&
					EmailSend({
						variables: {
							body: {
								Header: `${selectedOutlet?.name} has shared you a file `,
								Body: body,
							},
							outletID: selectedOutlet?.ID,
							email:email,
							attachments: {
								filename: `Average Meal Time Analysis - ${selectedOutlet?.name}.jpg`,
								path: shareAttachment?.fileURL,
								cid: QRContentString,
							},
						},
					}).then(x => {
						if (x?.data?.emailSend === true) {
							snackFunc('Sent Email Successfully!', false);
							setOpenShareDialog(false);
						} else {
							snackFunc('Sent Email Fail!', false);
						}
					});
			}, [openSendEmail]);
		
				const shareReceiptRef = document.getElementById('AVERAGE-MEAL-TIME');
				
					useEffect(() => {
						if (openShareDialog) {
							const timeoutId = setTimeout(() => {
								if (shareReceiptRef) {
									const attachment = shareReceiptRef;
									console.log('attachment',attachment);
									
									htmlToImage
										.toBlob(attachment, {
											style: { background: '#ffffff' },
											cacheBust: true,
										})
										.then(value => {
											console.log('value', value);
											
											onSubmit(value);
										})
										.catch(error => {
											console.error('Error generating image blob:', error);
										});
								} else {
									console.error('Element with id "share-receipt" not found.');
								}
							}, 100); // Delay execution to allow for rendering
				
							return () => clearTimeout(timeoutId); // Cleanup timeout on unmount
						}
					}, [openShareDialog]);

	useEffect(() => {
		if (selectedOutlet) {
			loadAverageMealTimeAnalysis({
				variables: {
					outletID: selectedOutlet?.ID,
				},
			});
		}
	}, [selectedOutlet]);

	const renderCustomizedLabel = (props: any) => {
		const { x, y, width, height, value } = props;
		const radius = 10;
		return (
			<g>
				<text
					x={width + radius - y - height}
					y={x + width / 2 + 2}
					transform={`rotate(-90)`}
					fill="#fff"
					textAnchor="middle"
					dominantBaseline="middle"
					fontSize="12px"
				>
					{`${value} mins`}
				</text>
			</g>
		);
	};

	const CustomizedXAxisLabel = () => {
		return (
			<>
				<text
					x={0}
					y={0}
					dx="50%"
					dy="5%"
					textAnchor="middle"
					dominantBaseline="middle"
					fontSize={16}
					fontWeight={500}
					width={180}
				>
					{`${selectedOutlet?.name} `}
				</text>
				<text
					x={0}
					y={0}
					dx="50%"
					dy="10%"
					textAnchor="middle"
					dominantBaseline="middle"
					fontSize={12}
					fontWeight={350}
					width={180}
				>
					{'Average Meal Time Analysis'}
				</text>
			</>
		);
	};
	const CustomizedYAxisLabel = () => {
		return (
			<text
				x={0}
				y={0}
				dx="-150px"
				dy="5%"
				textAnchor="middle"
				dominantBaseline="middle"
				fontSize={12}
				fontWeight={500}
				width={180}
				transform="rotate(-90)"
			>
				Meal Duration (mins)
			</text>
		);
	};

	const onSubmit = blob => {
		getShareAttachment({
			variables: {
				file: blob,
				outletID: selectedOutlet?.ID,
			},
		});
	};

	return (
		<>
			<>
				<MainHeader
					onClick={() =>
						history.push({
							pathname: `/menu/outlet-app/business-insight/business-analytic`,
						})
					}
					mainBtn="back"
					smTitle="Business Insights"
					// HC
					title={loggedInUser?.companyName}
					routeSegments={[
						{ name: 'Business Insights' },
						{ name: 'Average Meal Time Analysis', current: true },
					]}
				/>

				<DynamicSubHeader
					style={
						{
							// width:
							// 	isDesktop && globalState.drawerOpen
							// 		? 'calc(100% - 288px)'
							// 		: isDesktop && !globalState.drawerOpen
							// 		? `calc(100% - 48px)`
							// 		: null,
						}
					}
					title={
						getOutlet === undefined || getOutlet?.length === 0
							? ``
							: `${selectedOutlet?.name}`
					} // title text
					handleClick={e => handleClick(e, null, 0)} // onClick function for dropdown
					dropDownOptions={
						// dropdown component place here
						<StyledMenu
							id="customized-menu"
							anchorEl={anchorEl}
							keepMounted
							open={Boolean(anchorEl)}
							onClose={handleClose}
							onClick={handleClose}
						>
							{getOutlet.map((outlet, index) => (
								<StyledMenuItem
									key={index}
									value={outlet.ID}
									defaultValue={outlet.ID}
									onClick={e => {
										setSelectedOutlet(outlet);
									}}
								>
									<ListItemText primary={outlet?.name} />
								</StyledMenuItem>
							))}
						</StyledMenu>
					}
				/>
				<ContentWrapper search float>
					<div  id='AVERAGE-MEAL-TIME'>
					{!averageMealTimeAnalysisLoading &&
					(averageMealTimeAnalysis === undefined ||
						averageMealTimeAnalysis?.length === 0) ? (
						<EmptyList
							title={`No order item created for ${selectedOutlet?.name}`}
							subtitle="Please create new order to continue"
						/>
					) : (
						!averageMealTimeAnalysisLoading && (
							<>
								{avgMealTimeBarChart(
									averageMealTimeAnalysis,
									CustomizedXAxisLabel,
									CustomizedYAxisLabel,
									renderCustomizedLabel,
								)}
								{avgMealTimeBarChart(
									averageMealTimeAnalysis,
									CustomizedXAxisLabel,
									CustomizedYAxisLabel,
									renderCustomizedLabel,
									true,
								)}
								<div className="cover-layer">
									<CardContents>
										<></>
									</CardContents>
								</div>
							</>
						)
					)}
					</div>
				</ContentWrapper>
				{ShareDialog({
					shareTitle: `Average Meal Time Analysis - ${selectedOutlet?.name}`,
					title: `Share`,
					URL: shareAttachment?.fileURL,
					setSimple: setOpenShareDialog,
						simple: openShareDialog,
						emailShare:email,
						setSimpleEmail: setOpenSendEmail,
						isReceipt: true,
						phoneNumber: phoneNumber,
						setOpenPhoneNum: setOpenPhoneNum,
						setOpenEmail: setOpenEmail,
					})}

				<PhoneNumDialog
					open={openPhoneNum}
					setOpen={setOpenPhoneNum}
					shareTitle={`Average Meal Time Analysis - ${selectedOutlet?.name}`}
					URL={shareAttachment?.fileURL}
				/>
	
				<EmailDialog
					open={openEmail}
					setOpen={setOpenEmail}
					setSimpleEmail={setOpenSendEmail}
					setEmail={setEmail}
				/>

				<DynamicFooter
					overlap
					// isHidden={openShareDialog}
					options={[
						// {
						// 	name: 'Share',
						// 	onClick: async () => {
						// 		let temp = await document.getElementById('hiddenBarChart');
						// 		htmlToImage
						// 			.toBlob(temp, { style: { background: '#fff' } })
						// 			.then(value => {
						// 				onSubmit(value);
						// 			});
						// 	},
						// 	disabled:
						// 		averageMealTimeAnalysis == undefined ||
						// 		averageMealTimeAnalysis.length == 0,
						// 	color: 'primary',
						// 	props: {
						// 		type: 'submit',
						// 	},
						// 	startIcon: <ShareIcon style={{ fontSize: '18px' }} />,
						// },
						{
							name: 'Share',
								onClick: () => {
									setOpenShareDialog(true);
								},
							disabled:
											averageMealTimeAnalysis == undefined ||
											averageMealTimeAnalysis.length == 0,
							color:  averageMealTimeAnalysis == undefined ||
										  averageMealTimeAnalysis.length == 0 ? 'inherit' : 'primary',
							props: {
									type: 'submit',
								},
								startIcon: <ShareIcon style={{ fontSize: '18px' }} />,
							},
					]}
					
				/>
					<SnackBarMsg open={openSnackBar} message={snackBarMessage} />
			</>
		</>
	);
};

const heightConst = 300;
const avgMealTimeBarChart = (
	averageMealTimeAnalysis,
	CustomizedXAxisLabel,
	CustomizedYAxisLabel,
	renderCustomizedLabel,
	hidden?: Boolean,
) => {
	return (
		<div
			style={
				hidden
					? {
							zIndex: -40,
							top: 0,
							left: 0,
							position: 'fixed',
							width: '100%',
					  }
					: {
							marginTop: '0px',
							zIndex: 40,
							position: 'relative',
					  }
			}
			className={hidden ? 'hidden-content' : null}
		>
			<CardContents
				section={
					!hidden
						? {
								header: {
									title: 'Average Meal Time Analysis',
								},
						  }
						: null
				}
			>
				<div
					style={{
						width: '100%',
						height: !hidden ? heightConst : heightConst + 44,
					}}
					id={!hidden ? 'barChart' : 'hiddenBarChart'}
				>
					<ResponsiveContainer>
						<BarChart
							id="barChart"
							data={averageMealTimeAnalysis}
							margin={{
								top: hidden ? 50 : 10,
								right: 10,
								left: 10,
								bottom: 10,
							}}
						>
							<CartesianGrid strokeDasharray="2 3" />
							<XAxis
								dataKey="name"
								fontSize={12}
								axisLine={false}
								tickLine={false}
								label={hidden ? CustomizedXAxisLabel : null}
							/>
							<YAxis
								label={<CustomizedYAxisLabel />}
								fontSize={10}
								axisLine={false}
								tickLine={false}
							/>
							<Tooltip />
							<Bar
								dataKey="average"
								name="Mins"
								fill="#4ba0ea"
								barSize={39}
								values="average"
							>
								<LabelList
									dataKey="average"
									fill="#fff"
									textAnchor="end"
									angle={-90}
									dominantBaseline="end"
									content={renderCustomizedLabel}
								/>
								{averageMealTimeAnalysis.map((entry, index) => (
									<Cell key={`cell-${index}`} fill={COLORS[index % 20]} />
								))}
							</Bar>
						</BarChart>
					</ResponsiveContainer>
				</div>
			</CardContents>
		</div>
	);
};
